import PackageAdditionalServiceEnum from '~/enums/PackageAdditionalServiceEnum'
import type { PackageInterface } from '~/types/shipzeePro/packagesTypes'

import shipmentFindService from '~/utils/shipzeePro/shipmentFindService'

export default function getInspectPackagePrice(shipment: PackageInterface, alternativePrice?: number) {
  const serviceData = shipmentFindService(shipment, PackageAdditionalServiceEnum.InspectPackage)
  if (serviceData) {
    if (serviceData.service_price !== null) {
      return serviceData.service_price
    }

    if (alternativePrice) {
      return alternativePrice
    }
  }

  return null
}
